import { render, staticRenderFns } from "./TaskViewDetail.vue?vue&type=template&id=214d3476&scoped=true"
import script from "./TaskViewDetail.vue?vue&type=script&lang=js"
export * from "./TaskViewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d3476",
  null
  
)

export default component.exports